angular.module("app").controller("SetMaintenancePopupController", [
    '$scope',
    '$uibModalInstance',
    'errorHandler',
    'logger',

    function ($scope, $modalInstance, errorHandler, logger) {

        (function () {
            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };
            $scope.state = {};

        })();

        $scope.save = function () {
           if ($scope.state.start_date && $scope.state.end_date && !moment($scope.state.end_date).isAfter(moment($scope.state.start_date))) {
                logger.logError("Start date must be before end date");
                return;
           }

            $modalInstance.close($scope.state);
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.state.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.state.end_date = $scope.vm.toDate;
            }

        };


        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
